<template>
    <fieldset class="forms setting-schedule horizental-schedule">
        <legend>스케줄 설정</legend>
        <div class="form-item" style="margin-right: 5px;">
            <p>{{ $t('POLICY.ADD_POPUP.SCHEDULE_CYCLE')}}</p>
            <select-box-single 
                select-id="select_schedule"
                select-class="type-single mt-2"
                :select-box-options="periodOptions"
                :select-box-value="selObj.selBaseType"
                :use-translate="true"
                @onSelectChange="changePeri($event)"></select-box-single>
        </div>

        <div class="form-item relative">
            <p>{{ $t('POLICY.ADD_POPUP.SCHEDULE_PERIOD')}}</p>
            <div class="hstack">
                <!-- Monthly-->
                <div>
                    <span v-show="selObj.selBaseType && selObj.selBaseType == 'M'">
                        <select-box-single 
                            select-id="select_schedule_dayOfMonth"
                                select-class="type-single mt-2"
                                :select-box-options="dayOfMonth"
                                :select-box-value="selObj.selDayOfMonth"
                                select-value="value"
                                select-text="value"
                                @onSelectChange="selObj.selDayOfMonth = $event.value"></select-box-single>
                    </span>

                    <!--Weekly-->
                    <span  v-show="selObj.selBaseType && selObj.selBaseType == 'W'">
                        <select-box-single 
                            select-id="select_schedule_dayOfWeek"
                            select-class="type-single mt-2"
                            :select-box-options="dayOfWeek"
                            :select-box-value="selObj.selDayOfWeek"
                            select-value="value"
                            select-text="day"
                            :use-translate="true"
                            @onSelectChange="selObj.selDayOfWeek = $event.value"></select-box-single>
                    </span>

                    <!--Daily-->
                    <span v-show="selObj.selBaseType">
                        <select-box-single 
                            select-id="select_schedule_timeInfo"
                            select-class="type-single mt-2"
                            :select-box-options="timeInfo"
                            :select-box-value="selObj.selTime"
                            select-value="value"
                            select-text="value"
                            @onSelectChange="selObj.selTime = $event.value"></select-box-single>
                    </span>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script>
    import searchEmailUser from '../common/searchEmailUser.vue'
    import {mapGetters} from "vuex";
    export default {
        name: 'HorizontalSchedule',
        components:{
            searchEmailUser
        },
        props: {
            cmplId: String,
            callSetScheInfo: {
                type: Function,
                default: ()=>{}
            }
        },
        data() {
            return {
                scheInfo: {},
                periodOptions : [
                    {'key' : 'D', 'val' : 'COMMON.SCHEDULE.EVERY_DAY'},
                    {'key' : 'W', 'val' : 'COMMON.SCHEDULE.EVERY_WEEK'},
                    {'key' : 'M', 'val' : 'COMMON.SCHEDULE.EVERY_MONTH'}
                ],
                dayOfMonth : [
                     {'value' : '1'}, {'value' : '2'}, {'value' : '3'}, {'value' : '4'}, {'value' : '5'}
                    , {'value' : '6'}, {'value' : '7'}, {'value' : '8'}, {'value' : '9'}, {'value' : '10'}
                    , {'value' : '11'}, {'value' : '12'}, {'value' : '13'}, {'value' : '14'}, {'value' : '15'}
                    , {'value' : '16'}, {'value' : '17'}, {'value' : '18'}, {'value' : '19'}, {'value' : '20'}
                    , {'value' : '21'}, {'value' : '22'}, {'value' : '23'}, {'value' : '24'}, {'value' : '25'}
                    , {'value' : '26'}, {'value' : '27'}, {'value' : '28'}, {'value' : '29'}, {'value' : '30'},
                    {'value' : '31'}
                ],
                dayOfWeek : [
                     {'value' : '1', 'day' : 'COMMON.SCHEDULE.day_of_week_monday'}
                    , {'value' : '2', 'day' : 'COMMON.SCHEDULE.day_of_week_tuesday'}
                    , {'value' : '3', 'day' : 'COMMON.SCHEDULE.day_of_week_wednesday'}
                    , {'value' : '4', 'day' : 'COMMON.SCHEDULE.day_of_week_thursday'}
                    , {'value' : '5', 'day' : 'COMMON.SCHEDULE.day_of_week_friday'}
                    , {'value' : '6', 'day' : 'COMMON.SCHEDULE.day_of_week_saturday'}
                    , {'value' : '7', 'day' : 'COMMON.SCHEDULE.day_of_week_sunday'}
                ],
                timeInfo : [
                      {'value' : '00:00'}, {'value' : '00:30'}, {'value' : '01:00'}, {'value' : '01:30'}, {'value' : '02:00'}, {'value' : '02:30'}, {'value' : '03:00'}, {'value' : '03:30'}
                    , {'value' : '04:00'}, {'value' : '04:30'}, {'value' : '05:00'}, {'value' : '05:30'}, {'value' : '06:00'}, {'value' : '06:30'}, {'value' : '07:00'}, {'value' : '07:30'}
                    , {'value' : '08:00'}, {'value' : '08:30'}, {'value' : '09:00'}, {'value' : '09:30'}, {'value' : '10:00'}, {'value' : '10:30'}, {'value' : '11:00'}, {'value' : '11:30'}
                    , {'value' : '12:00'}, {'value' : '12:30'}, {'value' : '13:00'}, {'value' : '13:30'}, {'value' : '14:00'}, {'value' : '14:30'}, {'value' : '15:00'}, {'value' : '15:30'}
                    , {'value' : '16:00'}, {'value' : '16:30'}, {'value' : '17:00'}, {'value' : '17:30'}, {'value' : '18:00'}, {'value' : '18:30'}, {'value' : '19:00'}, {'value' : '19:30'}
                    , {'value' : '20:00'}, {'value' : '20:30'}, {'value' : '21:00'}, {'value' : '21:30'}, {'value' : '22:00'}, {'value' : '22:30'}, {'value' : '23:00'}, {'value' : '23:30'}
                ],
                selObj : {
                    selBaseType: 'D',
                    selDayOfMonth:'1',
                    selDayOfWeek:'1',
                    selTime:'00:00'
                }

            }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            })
        },
        watch: {
            cmplId : function(){
                this.selectScheduleInfo()
            },
            'selObj.selBaseType'(newVal, olv) {
                this.scheInfo['day'] = 1;
                if (newVal == 'D') {
                    this.scheInfo['day'] = null;
                }
                this.scheInfo['dt'] = '00:00';
                this.scheInfo['peri'] = newVal;
                this.callSetScheInfo(this.scheInfo);
            },
            'selObj.selDayOfWeek'(newVal, olv) {
                this.scheInfo['day'] = newVal;
                this.callSetScheInfo(this.scheInfo);
            },
            'selObj.selDayOfMonth'(newVal, olv) {
                this.scheInfo['day'] = newVal;
                this.callSetScheInfo(this.scheInfo);
            },
            'selObj.selTime'(newVal, olv) {
                this.scheInfo['dt'] = newVal;
                this.callSetScheInfo(this.scheInfo);
            }
        },
        methods : {
            changePeri(event){
                this.selObj.selBaseType = event.value;
                this.selObj.selDayOfMonth='1';
                this.selObj.selDayOfWeek='1';
                this.selObj.selTime='00:00';
            },
            getSelectedValues() {
                const selObj = this.selObj;
                let day = 0;
                if (selObj.selBaseType == 'D') {
                    day = null;
                } else if (selObj.selBaseType == 'W') {
                    day = selObj.selDayOfWeek;
                } else {
                    day = selObj.selDayOfMonth;
                }
                let schdObj = {
                    // userList : this.$refs.SearchEmailUser.returnReceiver(),
                    'peri':selObj.selBaseType,
                    'dt' : selObj.selTime,
                    'browserTimeZone': moment().format('Z'),
                    day,
                }

                return schdObj;
            },

            async selectScheduleInfo(){
                var url = '/api/governance/schedule';
                var header = {
                    cmpnId : this.curCmpnId,
                    cmplId : this.cmplId
                };

                const response = await this.http.post(url, JSON.stringify(header));
                if(response.data.status === 'ok'){
                    if(response.data.result){
                        this.selObj.selBaseType = response.data.result.peri;
                        this.selObj.selDayOfMonth = response.data.result.day;
                        this.selObj.selDayOfWeek = response.data.result.day;
                        this.selObj.selTime = response.data.result.dt;
                    }
                }
            },
            closePopup(){
                this.Common.closePopup();
                this.selObj.selDayOfMonth='1'
                this.selObj.selDayOfWeek='1'
                this.selObj.selTime='00:00'
            }

        },
    }
</script>
<style scoped>
.form-item {
    display: inline-block;
    margin-top: 15px;
}
.form-item p {
    font-size: .75rem;
    width: 100%;
    height: 15px;
}
</style>
<style>
.horizental-schedule .type-single {
    min-width: unset !important;
    max-width: 125px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HorizontalSchedule.vue